export const styles = theme => ({
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    root: {
        flexGrow: 1,
    },
    fullWidth: {
        width: '90%'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '50%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '50%',
        color: theme.palette.text.secondary,
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },
    rowAvatars: {
        display: 'flex',
        marginLeft: '-10px'
    },
    avatar: {
        margin: 5,
    },
    bigAvatar: {
        width: 60,
        height: 60,
    },
});


// WEBPACK FOOTER //
// ./src/containers/builder/style/block_section.js